"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endpoint = exports.actions = exports.JellyContext = exports.EOSProvider = exports.EOS = void 0;
exports.getPDF = getPDF;
exports.pad = pad;
exports.useAddCustomerVehicles = useAddCustomerVehicles;
exports.useAddVehicleServiceHistory = useAddVehicleServiceHistory;
exports.useCustomerPreferences = useCustomerPreferences;
exports.useDeleteVehicleServiceHistory = useDeleteVehicleServiceHistory;
exports.useGetAllVehicleSubscriptions = useGetAllVehicleSubscriptions;
exports.useGetEngineTransDrive = useGetEngineTransDrive;
exports.useGetMaintenanceSchedule = useGetMaintenanceSchedule;
exports.useGetMasterPreferences = useGetMasterPreferences;
exports.useGetModelAndYears = useGetModelAndYears;
exports.useGetOptCodes = useGetOptCodes;
exports.useGetPrimaryVehicle = useGetPrimaryVehicle;
exports.useGetUserVehicles = useGetUserVehicles;
exports.useGetVehicleDealer = useGetVehicleDealer;
exports.useGetVehicleGuides = useGetVehicleGuides;
exports.useGetVehicleHealthHistory = useGetVehicleHealthHistory;
exports.useGetVehicleHealthReport = useGetVehicleHealthReport;
exports.useGetVehicleManuals = useGetVehicleManuals;
exports.useGetVehicleServiceHistory = useGetVehicleServiceHistory;
exports.useRemoveCustomerVehicle = useRemoveCustomerVehicle;
exports.useRenameVehicle = useRenameVehicle;
exports.useSetPreferredDealer = useSetPreferredDealer;
exports.useSetPreferredVehicle = useSetPreferredVehicle;
exports.useUpdateVehicleServiceHistory = useUpdateVehicleServiceHistory;
exports.useVehicleDealerService = useVehicleDealerService;
exports.useVehicleSpecifications = useVehicleSpecifications;
exports.withEOSProvider = void 0;
var _reactQuery = require("@tanstack/react-query");
var _axios = _interopRequireDefault(require("axios"));
var _react = require("react");
var _config = require("../../_nextgen/packages/config");
var _contextFunctions = _interopRequireDefault(require("../../_nextgen/packages/context-functions"));
var _useRawUserVehicles = _interopRequireDefault(require("../../_nextgen/store/user-vehicle/useRawUserVehicles"));
var _analytics = _interopRequireDefault(require("../../packages/analytics"));
var _Cookie = _interopRequireDefault(require("../../packages/Cookie"));
var _Dictionary = _interopRequireDefault(require("../../packages/Dictionary"));
var _env = _interopRequireDefault(require("../../utilities/env"));
var _id_token = _interopRequireDefault(require("../id_token"));
var _queryClient = require("../queryClient");
var _getReCAPTCHAToken = require("./getReCAPTCHAToken");
var _index = require("./index.types");
var _jsxRuntime = require("react/jsx-runtime");
//import type IJellyParams from "@tmna/seal-interfaces/lib/IJellyParams";

const endpoint = exports.endpoint = (0, _env.default)("REACT_APP_EOS_ENDPOINT");
const REFERRER_URL = (0, _env.default)("REACT_APP_REFERRER_URL") || window.location.hostname;
const endpoint_oauth = (0, _env.default)("REACT_APP_EOS_OAUTH_API_ENDPOINT");
const getEOSBaseUrl = function (intent, action) {
  return `${(0, _env.default)(`REACT_APP_EOS_V2_${intent}_ENDPOINT`)}${action}`;
};
const buildEOSEndpoint = function (url) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    intent
  } = services.find(function (service) {
    const actionUrl = Object.values(actions).find(function (action) {
      return url === action;
    });
    const actionKey = Object.keys(actions).find(function (key) {
      return actions[key] === actionUrl;
    });
    return service.actions.includes(actionKey);
  }) || {};
  return !intent ? endpoint + (0, _Dictionary.default)(url, params) : getEOSBaseUrl(intent, (0, _Dictionary.default)(url, params));
};
const apiClient = function (_ref) {
  let {
    oauth,
    captcha = false,
    headers = {},
    opts = {},
    params = {}
  } = _ref;
  const axiosInstance = _axios.default.create({
    headers: getHeaders({
      headers,
      mode: process.env.NODE_ENV
    }),
    ...opts
  });
  axiosInstance.interceptors.request.use(async function (config) {
    config.url = buildEOSEndpoint(config.url, params);
    if (oauth) {
      config.headers.Authorization = await getOAuthToken(oauth);
    }
    if (captcha) {
      if (config.method !== "get") {
        config.data = {
          ...config.data,
          tokenAttributes: {
            xauthToken: await (0, _getReCAPTCHAToken.getReCAPTCHAToken)(),
            xconsumer: (0, _env.default)("REACT_APP_RECAPTCHA_CONSUMER") || "LD",
            xreferrer: REFERRER_URL
          }
        };
      } else {
        config.headers["x-auth-token"] = await (0, _getReCAPTCHAToken.getReCAPTCHAToken)();
        config.headers["x-consumer"] = (0, _env.default)("REACT_APP_RECAPTCHA_CONSUMER") || "LD";
        config.headers["x-referrer"] = REFERRER_URL;
      }
    }
    return config;
  });
  return axiosInstance;
};
const EOS = exports.EOS = {
  serviceManagement: function (_ref2) {
    let {
      vin,
      oauth,
      captcha,
      memberServiceHistoryId
    } = _ref2;
    return apiClient({
      oauth,
      captcha,
      params: {
        vin,
        memberServiceHistoryId
      }
    });
  },
  vehicleMaintenance: function (_ref3) {
    let {
      oauth,
      captcha = true
    } = _ref3;
    return apiClient({
      captcha,
      oauth
    });
  },
  vehicleManagement: function (_ref4) {
    let {
      vehicleId,
      vin,
      model,
      year
    } = _ref4;
    return apiClient({
      params: {
        vehicleId,
        vin,
        model,
        year
      },
      captcha: true
    });
  },
  vehicleHealth: function (_ref5) {
    let {
      vin
    } = _ref5;
    return apiClient({
      params: {
        vin
      }
    });
  },
  vehicleInfo: function (_ref6) {
    let {
      oauth
    } = _ref6;
    return apiClient({
      oauth,
      captcha: true
    });
  }
};
const services = [{
  intent: _index.EOSEndpointServiceIntent.SERVICE_MANAGEMENT,
  actions: ["getOptCodes", "getSafetyCampaigns", "getMasterPreferences", "getAllVehicleSubscriptions", "addVehicleServiceHistory", "getVehicleServiceHistoryDealer", "getVehicleServiceHistory", "updateVehicleServiceHistory", "deleteVehicleServiceHistory"]
}, {
  intent: _index.EOSEndpointServiceIntent.VEHICLE_MAINTENANCE,
  actions: ["getModelAndYears", "getVehicleManuals", "maintenanceSchedule", "getVinMaintenanceSchedule", "getMaintenanceSchedule", "getEngineTransDrive"]
}, {
  intent: _index.EOSEndpointServiceIntent.VEHICLE_MANAGEMENT,
  actions: ["getUserVehicles", "setPreferredDealer", "addCustomerVehicles", "removeCustomerVehicle", "renameVehicle", "setPreferredVehicle", "getVehicleDealer"]
}, {
  intent: _index.EOSEndpointServiceIntent.VEHICLE_HEALTH,
  actions: ["getVhr", "getVehicleHealthHistory"]
}, {
  intent: _index.EOSEndpointServiceIntent.VEHICLE_INFO,
  actions: ["getModelAndYears", "getSafetyCampaigns", "getVehicleSpecs"]
}];
const actions = exports.actions = {
  getModelAndYears: "/v1/vehicle/model-year-list?format=model-year",
  getVehicleManuals: "/v2/vehicle/manual",
  getOptCodes: "/v1/vehicle/service-op-codes",
  getSafetyCampaigns: "/v2/vehicle/safety-campaigns",
  getMasterPreferences: "/v1/customer/communication/master-preferences",
  customerPreferences: "/v1/customer/communication/preferences",
  getAllVehicleSubscriptions: "/v1/customer/subscriptions",
  getUserVehicles: "/v1/customer/vehicles",
  setPreferredDealer: "/v1/customer/preferred-dealer",
  addCustomerVehicles: "/v1/customer/vehicles",
  maintenanceSchedule: "/v1/vehicle/maintenance-schedule?vin={vin}&lastKnownMileage=",
  getVhr: "/v1/vehicle/{vin}/vehicle-health-report",
  getVehicleHealthHistory: "/v1/vehicle/{vin}/vehicle-health-history",
  addVehicleServiceHistory: "/v1/vehicle/{vin}/self",
  getVehicleServiceHistoryDealer: "/v1/vehicle/{vin}/self/?serviceType=NSH",
  getVehicleServiceHistory: "/v1/vehicle/{vin}/self/?serviceType=THIRD",
  updateVehicleServiceHistory: "/v1/vehicle/{vin}/service-records/{memberServiceHistoryId}",
  deleteVehicleServiceHistory: "/v1/vehicle/{vin}/service-records/{memberServiceHistoryId}",
  removeCustomerVehicle: "/v1/customer/vehicles/{vin}?reason=disposed&model={model}&modelYear={year}",
  renameVehicle: "/v1/customer/vehicles/{vehicleId}",
  setPreferredVehicle: "/v1/customer/vehicles/{vehicleId}",
  getVinMaintenanceSchedule: "/v2/vehicle/maintenance-schedule",
  getMaintenanceSchedule: "/v2/vehicle/maintenance-scheduled",
  getEngineTransDrive: "/v2/vehicle/engine-transmission-drive",
  getVehicleSpecs: "/v2/vehicle/specification",
  getPDF: "/v1/vehicle/{vin}/vehicle-health-report/{vhrId}/pdf",
  getVehicleDealer: "/v1/vehicle/{vin}/dealer"
};
const oauth = {
  getModelAndYears: "modelYear",
  getSafetyCampaigns: "safetyCampaign",
  getVehicleManuals: "manuals",
  getMasterPreferences: "masterPreferences",
  getOptCodes: "optCodes",
  getMaintenanceSchedule: "maintenanceScheduleDmy",
  getMaintenanceScheduleVIN: "maintenanceschedulevin",
  getEngineTransDrive: "maintenanceScheduleEtd",
  getVehicleSpecs: "vehicleSpecs"
};
function pad(input, size) {
  let num = (input === null || input === void 0 ? void 0 : input.toString()) || "";
  while (num.length < size) num = `0${num}`;
  return num;
}
function getModelFromTrim() {
  let trim = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return trim === null || trim === void 0 ? void 0 : trim.replace(/([0-9\s]+)/g, "");
}
const generateVehicleImageEndpoint = function (vehicle) {
  if (!vehicle || typeof vehicle !== "object") return undefined;
  const {
    vehicleId,
    year,
    model,
    exteriorColorCode
  } = vehicle;
  const query = `vehicleId:${vehicleId};year:${year};model:${getModelFromTrim(model)};trim:${model}${exteriorColorCode ? `;code:${pad(exteriorColorCode, 4)}` : ""}`;
  if (!query) return undefined;
  return `/rest/lexusdrivers/vehicledata?type=all&multipleVehicles=${query}`;
};
const generateVehicleImagesEndpoint = function () {
  let vehicles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!Array.isArray(vehicles) || vehicles.length === 0) return undefined;
  const query = vehicles.map(function (v) {
    return `vehicleId:${v === null || v === void 0 ? void 0 : v.vehicleId};year:${v === null || v === void 0 ? void 0 : v.year};model:${getModelFromTrim(v === null || v === void 0 ? void 0 : v.model)};trim:${v === null || v === void 0 ? void 0 : v.model}${v !== null && v !== void 0 && v.exteriorColorCode ? `;code:${pad(v === null || v === void 0 ? void 0 : v.exteriorColorCode, 4)}` : ""}`;
  }).join(",");
  if (!query) return undefined;
  return `/rest/lexusdrivers/vehicledata?type=all&multipleVehicles=${query}`;
};
const EOSProvider = exports.EOSProvider = _queryClient.QueryProvider;
const withEOSProvider = function (Component) {
  return function (props) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(EOSProvider, {
      "data-testid": "withEOSProvider",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
        ...props
      })
    });
  };
};
exports.withEOSProvider = withEOSProvider;
const getHeaders = function (_ref7) {
  let {
    headers,
    mode = "production"
  } = _ref7;
  const [id_token] = (0, _Cookie.default)("id_token");
  const [id_token_local] = (0, _Cookie.default)("id_token_local");
  const [id_token_tmnab2cqa] = (0, _Cookie.default)("id_token_tmnab2cqa");
  const auth = (mode !== "production" ? id_token_local : undefined) || id_token || id_token_tmnab2cqa || _id_token.default || "";
  const retHeaders = {
    "x-brand": (0, _env.default)("REACT_APP_EOS_BRAND") || "L",
    Authorization: auth,
    // id_token or oauth token
    ...headers
  };

  // Delete undefined keys
  Object.keys(retHeaders).forEach(function (key) {
    return retHeaders[key] === undefined ? delete retHeaders[key] : {};
  });
  return retHeaders;
};
const truncateMessage = function (message, minChars, maxChars) {
  return message && (message.length > maxChars ? message.slice(minChars, maxChars) : message);
};
const oauthClient = function () {
  let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _axios.default.create({
    ...opts
  });
};
function getOAuthToken(path) {
  return oauthClient().post(endpoint_oauth, {
    resource: path
  }).then(function (data) {
    var _data$data, _data$data$body, _data$data$body$data;
    return data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : (_data$data$body = _data$data.body) === null || _data$data$body === void 0 ? void 0 : (_data$data$body$data = _data$data$body.data) === null || _data$data$body$data === void 0 ? void 0 : _data$data$body$data.AccessToken;
  });
}
const getQueryKey = function (queryNames) {
  if (Array.isArray(queryNames)) {
    const queryNamesWithoutNull = queryNames.filter(function (queryName) {
      return typeof queryName === "string";
    });
    return ["eos"].concat(queryNamesWithoutNull);
  }
  return [];
};
const getvehicleMaintenance = function () {
  return EOS.vehicleMaintenance({
    oauth: oauth.getModelAndYears,
    captcha: false
  }).get(actions.getModelAndYears);
};
function useGetModelAndYears() {
  return (0, _reactQuery.useQuery)(getQueryKey(["modelYearList"]), getvehicleMaintenance, {
    select: function (responseData) {
      var _responseData$data, _responseData$data$da;
      return (responseData === null || responseData === void 0 ? void 0 : (_responseData$data = responseData.data) === null || _responseData$data === void 0 ? void 0 : (_responseData$data$da = _responseData$data.data) === null || _responseData$data$da === void 0 ? void 0 : _responseData$data$da.vehicleModelYearList) || [];
    }
  });
}
function useGetVehicleManuals(_ref8) {
  let {
    model,
    year,
    vin
  } = _ref8;
  const queryKey = model && year && !vin ? {
    model,
    year
  } : {
    vin
  };
  return (0, _reactQuery.useQuery)(getQueryKey(["vehicle-manuals", ...Object.values(queryKey)]), function () {
    return EOS.vehicleMaintenance({
      oauth: oauth.getVehicleManuals
    }).post(actions.getVehicleManuals, {
      keyword: "all",
      ...queryKey
    });
  }, {
    enabled: !!(model && year || !!(vin !== null && vin !== void 0 && vin.length)),
    select: function (data) {
      var _data$data2;
      return data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.data;
    }
  });
}
function useGetVehicleGuides(_ref9) {
  let {
    model,
    year
  } = _ref9;
  const hasModelAndYear = model && year;
  return (0, _reactQuery.useQuery)(getQueryKey(["vehicle-guides", model, year]), function () {
    return _axios.default.get(`/rest/lexusdrivers/vehicledocs?year=${year}&model=${encodeURIComponent(model)}`);
  }, {
    enabled: !!hasModelAndYear,
    select: function (responseData) {
      return responseData !== null && responseData !== void 0 && responseData.data ? {
        ...responseData.data
      } : {
        data: responseData
      };
    }
  });
}
const getMasterPreferences = function () {
  return apiClient({
    oauth: oauth.getMasterPreferences
  }).get(actions.getMasterPreferences);
};
function useGetMasterPreferences() {
  return (0, _reactQuery.useQuery)(getQueryKey(["master-preferences"]), getMasterPreferences, {
    select: function (responseData) {
      return responseData !== null && responseData !== void 0 && responseData.data ? {
        ...responseData.data
      } : {
        data: responseData
      };
    }
  });
}
const getOptCodes = function () {
  return EOS.serviceManagement({
    oauth: oauth.getOptCodes
  }).get(actions.getOptCodes);
};
function useGetOptCodes() {
  var _data$data3, _data$data3$data;
  const {
    data,
    isLoading
  } = (0, _reactQuery.useQuery)(getQueryKey(["opt-codes"]), getOptCodes);
  return {
    serviceOptions: (data === null || data === void 0 ? void 0 : (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : (_data$data3$data = _data$data3.data) === null || _data$data3$data === void 0 ? void 0 : _data$data3$data.opCodes) || [],
    isLoading
  };
}
const getVehicleHealthReport = function (vin) {
  return apiClient({
    params: {
      vin
    }
  }).get(actions.getVhr);
};
function useGetVehicleHealthReport(vin) {
  let shouldFetchData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (0, _reactQuery.useQuery)(getQueryKey(["vehicle-health-report", vin]), function () {
    return getVehicleHealthReport(vin);
  }, {
    enabled: !!vin && shouldFetchData,
    select: function (responseData) {
      var _responseData$data2;
      return (responseData === null || responseData === void 0 ? void 0 : (_responseData$data2 = responseData.data) === null || _responseData$data2 === void 0 ? void 0 : _responseData$data2.data) || {};
    }
  });
}
const getVehicleDealer = function (vin) {
  return apiClient({
    captcha: false,
    params: {
      vin
    }
  }).get(actions.getVehicleDealer);
};
function useGetVehicleDealer(vin, enabled) {
  return (0, _reactQuery.useQuery)(getQueryKey(["vehicle-dealer", vin]), function () {
    return getVehicleDealer(vin);
  }, {
    enabled: !!vin && enabled,
    select: function (responseData) {
      var _response$body;
      const response = responseData !== null && responseData !== void 0 && responseData.data ? {
        ...responseData.data
      } : {
        data: responseData
      };
      return (response === null || response === void 0 ? void 0 : (_response$body = response.body) === null || _response$body === void 0 ? void 0 : _response$body.data) || {};
    }
  });
}
function useVehicleDealerService() {
  return async function (vin) {
    var _response$body$data, _response$body2;
    const data = await apiClient({
      captcha: false,
      params: {
        vin
      }
    }).get(actions.getVehicleDealer);
    const response = data !== null && data !== void 0 && data.data ? {
      ...(data === null || data === void 0 ? void 0 : data.data)
    } : {
      data
    };
    return (_response$body$data = response === null || response === void 0 ? void 0 : (_response$body2 = response.body) === null || _response$body2 === void 0 ? void 0 : _response$body2.data) !== null && _response$body$data !== void 0 ? _response$body$data : {};
  };
}
const getCustomerPreferences = function () {
  return apiClient({}).get(actions.customerPreferences);
};
function useCustomerPreferences() {
  return (0, _reactQuery.useQuery)(getQueryKey(["customer-preferences"]), getCustomerPreferences, {
    select: function (responseData) {
      return responseData !== null && responseData !== void 0 && responseData.data ? {
        ...responseData.data
      } : {
        data: responseData
      };
    }
  });
}
const getAllVehicleSubscriptions = function () {
  return apiClient({
    captcha: true
  }).get(actions.getAllVehicleSubscriptions);
};
function useGetAllVehicleSubscriptions(isLoggedIn) {
  return (0, _reactQuery.useQuery)(getQueryKey(["vehicle-subscriptions", isLoggedIn]), getAllVehicleSubscriptions, {
    enabled: !!isLoggedIn,
    select: function (responseData) {
      var _responseData$data3, _responseData$data3$d;
      return responseData === null || responseData === void 0 ? void 0 : (_responseData$data3 = responseData.data) === null || _responseData$data3 === void 0 ? void 0 : (_responseData$data3$d = _responseData$data3.data) === null || _responseData$data3$d === void 0 ? void 0 : _responseData$data3$d.vehicleSubscription;
    }
  });
}
const getVehicles = function () {
  return apiClient({
    captcha: true
  }).get(actions.getUserVehicles);
};
const getImages = function (imagesEndpoint) {
  return _axios.default.get(imagesEndpoint);
};
function useApiCall() {
  let apiCall = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  let deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    data,
    isInitialLoading,
    status
  } = (0, _reactQuery.useQuery)(deps, apiCall, options);
  const response = data !== null && data !== void 0 && data.data ? {
    ...(data === null || data === void 0 ? void 0 : data.data),
    isInitialLoading,
    status
  } : {
    data: data,
    isInitialLoading,
    status
  };
  return response;
}
function useGetUserVehicles(isLoggedIn) {
  const {
    data: vehicles = [],
    isInitialLoading,
    status
  } = (0, _useRawUserVehicles.default)({
    enabled: isLoggedIn,
    select: function (response) {
      if (!response) return undefined;
      return response.data;
    }
  });
  const imagesEndpoint = generateVehicleImagesEndpoint(vehicles);
  const shouldFetchImages = isLoggedIn && Array.isArray(vehicles) && imagesEndpoint;
  const {
    data: images = {}
  } = useApiCall(function () {
    return imagesEndpoint && _axios.default.get(imagesEndpoint);
  }, ["user-vehicles-images", imagesEndpoint], {
    enabled: !!shouldFetchImages
  });
  if (!Array.isArray(vehicles)) {
    return {
      status,
      vehicles: [],
      isInitialLoadingUserVehicles: isInitialLoading
    };
  }
  const mergedData = vehicles.map(function (v) {
    return {
      ...v,
      ...((images === null || images === void 0 ? void 0 : images[v.vehicleId]) || [])
    };
  });
  const data = {
    status,
    vehicles: mergedData,
    isInitialLoadingUserVehicles: isInitialLoading
  };
  return data;
}
const JellyContext = exports.JellyContext = (0, _contextFunctions.default)();
const fetchVehicleImageData = async function (vehicle) {
  try {
    const imageEndpoint = generateVehicleImageEndpoint(vehicle);
    if (!imageEndpoint) throw new Error("Image endpoint is undefined");
    const response = await _axios.default.get(imageEndpoint);
    if (response.status === 200) {
      const data = response.data.data;
      const vehicleId = Object.keys(data)[0];
      const {
        banner
      } = data[vehicleId];
      return {
        imageSrc: banner === null || banner === void 0 ? void 0 : banner.desktopImage
      };
    }
    return {
      imageSrc: null
    };
  } catch (error) {
    return {
      imageSrc: null
    };
  }
};
const getJelly = JellyContext.inject(fetchVehicleImageData);
function useGetPrimaryVehicle(vehicle) {
  const {
    SEAL
  } = (0, _config.useConfig)();
  const getJelly = (SEAL === null || SEAL === void 0 ? void 0 : SEAL.getJellyImage) || fetchVehicleImageData;
  return (0, _reactQuery.useQuery)(getQueryKey(["user-jelly-vehicle-image", vehicle === null || vehicle === void 0 ? void 0 : vehicle.vehicleId]), function () {
    return getJelly(vehicle);
  }, {
    enabled: !!vehicle,
    cacheTime: 0,
    staleTime: 0,
    select: function (responseData) {
      return {
        ...vehicle,
        jellyImageUrl: responseData
      };
    }
  });
}
const getServiceManagementHistory = function (vin) {
  return EOS.serviceManagement({
    vin
  }).get(actions.getVehicleServiceHistory);
};
const getVehicleServiceHistoryDealer = function (vin) {
  return EOS.serviceManagement({
    vin
  }).get(actions.getVehicleServiceHistoryDealer);
};
function useGetVehicleServiceHistory(vin) {
  var _data$data4, _dealerData$data;
  const {
    data,
    isLoading
  } = (0, _reactQuery.useQuery)(getQueryKey(["vehicle-service-history", vin]), function () {
    return getServiceManagementHistory(vin);
  }, {
    enabled: !!vin
  });
  const {
    data: dealerData
  } = (0, _reactQuery.useQuery)(getQueryKey(["vehicle-service-history-dealer", vin]), function () {
    return getVehicleServiceHistoryDealer(vin);
  }, {
    enabled: !!vin
  });
  const {
    serviceHistoryRecords = []
  } = (data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.data) || {};
  const {
    repairOrders = []
  } = (dealerData === null || dealerData === void 0 ? void 0 : (_dealerData$data = dealerData.data) === null || _dealerData$data === void 0 ? void 0 : _dealerData$data.data) || {};
  const combinedData = (0, _react.useMemo)(function () {
    return {
      serviceHistoryRecords,
      repairOrders
    };
  }, [serviceHistoryRecords, repairOrders]);
  return {
    data: combinedData,
    isLoading
  };
}
function useAddVehicleServiceHistory(vin) {
  const fireAnalytics = (0, _analytics.default)("AddServiceHistory");
  const client = (0, _reactQuery.useQueryClient)();
  const data = (0, _reactQuery.useMutation)({
    mutationFn: function (args) {
      return EOS.serviceManagement({
        vin
      }).post(actions.addVehicleServiceHistory, {
        ...args
      }).catch(function (error) {
        var _error$response, _error$response$data, _error$response$data$, _error$response2, _error$response2$data, _error$response2$data2, _error$response3, _error$response3$data;
        const truncatedError = truncateMessage(error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.error) === null || _error$response$data$ === void 0 ? void 0 : _error$response$data$.detail, 0, 100);
        fireAnalytics("error", {
          code: error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : (_error$response2$data2 = _error$response2$data.error) === null || _error$response2$data2 === void 0 ? void 0 : _error$response2$data2.code,
          errorMessage: truncatedError
        });
        return Promise.reject(error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : _error$response3$data.error);
      }).then(function (data) {
        if (data !== null && data !== void 0 && data.error) {
          var _data$error, _data$error2;
          fireAnalytics("error", {
            code: data === null || data === void 0 ? void 0 : (_data$error = data.error) === null || _data$error === void 0 ? void 0 : _data$error.code,
            errorMessage: truncateMessage(data === null || data === void 0 ? void 0 : (_data$error2 = data.error) === null || _data$error2 === void 0 ? void 0 : _data$error2.detail, 0, 100)
          });
          return Promise.reject(data === null || data === void 0 ? void 0 : data.error);
        }
        return data;
      });
    },
    onSettled: async function () {
      await client.invalidateQueries(["vehicle-service-history"]);
      await client.invalidateQueries(["vehicle-service-history-dealers"]);
    }
  });
  return data;
}
function useUpdateVehicleServiceHistory(vin) {
  const fireAnalytics = (0, _analytics.default)("UpdateServiceHistory");
  const client = (0, _reactQuery.useQueryClient)();
  return (0, _reactQuery.useMutation)({
    mutationFn: function (_ref10) {
      let {
        memberServiceHistoryId,
        ...args
      } = _ref10;
      return EOS.serviceManagement({
        vin,
        memberServiceHistoryId
      }).patch(actions.updateVehicleServiceHistory, {
        ...args
      }).catch(function (error) {
        var _error$response4, _error$response4$data, _error$response4$data2, _error$response5, _error$response5$data, _error$response5$data2, _error$response6, _error$response6$data;
        const truncatedError = truncateMessage(error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : (_error$response4$data2 = _error$response4$data.error) === null || _error$response4$data2 === void 0 ? void 0 : _error$response4$data2.detail, 0, 100);
        fireAnalytics("error", {
          code: error === null || error === void 0 ? void 0 : (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : (_error$response5$data = _error$response5.data) === null || _error$response5$data === void 0 ? void 0 : (_error$response5$data2 = _error$response5$data.error) === null || _error$response5$data2 === void 0 ? void 0 : _error$response5$data2.code,
          errorMessage: truncatedError
        });
        return Promise.reject(error === null || error === void 0 ? void 0 : (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : (_error$response6$data = _error$response6.data) === null || _error$response6$data === void 0 ? void 0 : _error$response6$data.error);
      }).then(function (data) {
        if (data !== null && data !== void 0 && data.error) {
          var _data$error3, _data$error4;
          fireAnalytics("error", {
            code: data === null || data === void 0 ? void 0 : (_data$error3 = data.error) === null || _data$error3 === void 0 ? void 0 : _data$error3.code,
            errorMessage: truncateMessage(data === null || data === void 0 ? void 0 : (_data$error4 = data.error) === null || _data$error4 === void 0 ? void 0 : _data$error4.detail, 0, 100)
          });
          return Promise.reject(data === null || data === void 0 ? void 0 : data.error);
        }
        return data;
      });
    },
    onSettled: async function () {
      await client.invalidateQueries(["vehicle-service-history"]);
      await client.invalidateQueries(["vehicle-service-history-dealers"]);
    }
  });
}
function useDeleteVehicleServiceHistory(vin) {
  const fireAnalytics = (0, _analytics.default)("DeleteServiceHistory");
  const client = (0, _reactQuery.useQueryClient)();
  return (0, _reactQuery.useMutation)({
    mutationFn: function (memberServiceHistoryId) {
      return EOS.serviceManagement({
        vin,
        memberServiceHistoryId
      }).delete(actions.deleteVehicleServiceHistory).catch(function (error) {
        var _error$response7, _error$response7$data, _error$response7$data2, _error$response8, _error$response8$data, _error$response8$data2, _error$response9, _error$response9$data;
        fireAnalytics("error", {
          code: error === null || error === void 0 ? void 0 : (_error$response7 = error.response) === null || _error$response7 === void 0 ? void 0 : (_error$response7$data = _error$response7.data) === null || _error$response7$data === void 0 ? void 0 : (_error$response7$data2 = _error$response7$data.error) === null || _error$response7$data2 === void 0 ? void 0 : _error$response7$data2.code,
          errorMessage: truncateMessage(error === null || error === void 0 ? void 0 : (_error$response8 = error.response) === null || _error$response8 === void 0 ? void 0 : (_error$response8$data = _error$response8.data) === null || _error$response8$data === void 0 ? void 0 : (_error$response8$data2 = _error$response8$data.error) === null || _error$response8$data2 === void 0 ? void 0 : _error$response8$data2.detail, 0, 100)
        });
        return Promise.reject(error === null || error === void 0 ? void 0 : (_error$response9 = error.response) === null || _error$response9 === void 0 ? void 0 : (_error$response9$data = _error$response9.data) === null || _error$response9$data === void 0 ? void 0 : _error$response9$data.error);
      }).then(function (data) {
        if (data.error) {
          var _data$error5, _data$error6;
          fireAnalytics("error", {
            code: data === null || data === void 0 ? void 0 : (_data$error5 = data.error) === null || _data$error5 === void 0 ? void 0 : _data$error5.code,
            errorMessage: truncateMessage(data === null || data === void 0 ? void 0 : (_data$error6 = data.error) === null || _data$error6 === void 0 ? void 0 : _data$error6.detail, 0, 100)
          });
          return Promise.reject(data === null || data === void 0 ? void 0 : data.error);
        }
        return data;
      });
    },
    onSettled: async function () {
      await client.invalidateQueries(["vehicle-service-history"]);
      await client.invalidateQueries(["vehicle-service-history-dealers"]);
    }
  });
}
function useAddCustomerVehicles() {
  const client = (0, _reactQuery.useQueryClient)();
  return (0, _reactQuery.useMutation)({
    mutationFn: async function (_ref11) {
      let {
        modelYearList,
        vinList
      } = _ref11;
      return await apiClient({
        captcha: true
      }).post(actions.addCustomerVehicles, {
        modelYearList,
        VinList: vinList === null || vinList === void 0 ? void 0 : vinList.map(function (i) {
          return {
            vin: i
          };
        })
      });
    },
    onSettled: async function (_data, error) {
      if (!error) {
        return client.invalidateQueries(["user-vehicles"]);
      }
    },
    onMutate: async function () {
      await client.cancelQueries({
        queryKey: ["user-vehicles"]
      });
      // Snapshot the previous value
      const previousVehicles = client.getQueryData(["user-vehicles"]);
      return {
        previousVehicles
      };
    },
    onError: async function (_error, _variables, context) {
      await client.invalidateQueries(["user-vehicles"]);
      if (context !== null && context !== void 0 && context.previousVehicles) {
        client.setQueryData(["user-vehicles"], context.previousVehicles);
      }
    }
  });
}
function useRemoveCustomerVehicle() {
  const client = (0, _reactQuery.useQueryClient)();
  return (0, _reactQuery.useMutation)({
    mutationFn: async function (_ref12) {
      let {
        vin,
        model,
        year
      } = _ref12;
      return await EOS.vehicleManagement({
        vin,
        model,
        year
      }).delete(actions.removeCustomerVehicle);
    },
    onSuccess: async function () {
      return client.invalidateQueries({
        queryKey: ["user-vehicles"]
      });
    }
  });
}
function useSetPreferredVehicle() {
  const client = (0, _reactQuery.useQueryClient)();
  return (0, _reactQuery.useMutation)({
    mutationFn: async function (_ref13) {
      let {
        vehicleId,
        model,
        year
      } = _ref13;
      return await EOS.vehicleManagement({
        vehicleId
      }).patch(actions.setPreferredVehicle, {
        preferredVehicle: "Y",
        model: vehicleId && vehicleId.length > 17 ? model : undefined,
        year: vehicleId && vehicleId.length > 17 ? year : undefined
      });
    },
    onMutate: async function (_ref14) {
      let {
        vehicleId
      } = _ref14;
      await client.cancelQueries({
        queryKey: ["user-vehicles"]
      });

      // Snapshot the previous value
      const previousVehicles = client.getQueryData(["user-vehicles"]);

      // Optimistically update to the new value
      client.setQueryData(["user-vehicles"], function (vehicles) {
        var _vehicles$data, _vehicles$data$data;
        return vehicles === null || vehicles === void 0 ? void 0 : (_vehicles$data = vehicles.data) === null || _vehicles$data === void 0 ? void 0 : (_vehicles$data$data = _vehicles$data.data) === null || _vehicles$data$data === void 0 ? void 0 : _vehicles$data$data.reduce(function (acc, vehicle) {
          return [...acc, vehicle.vehicleId === vehicleId || vehicle.vin === vehicleId ? {
            ...vehicle,
            preferredVehicle: "Y"
          } : vehicle];
        }, []);
      });
      // Return a context object with the snapshotted value
      return {
        previousVehicles
      };
    },
    onError: function (_ref15) {
      let {
        context
      } = _ref15;
      client.setQueryData(["user-vehicles"], context.previousVehicles);
    },
    onSuccess: async function () {
      // invalidate onSuccess to force fetch of latest data
      return client.invalidateQueries({
        queryKey: ["user-vehicles"]
      });
    }
  });
}
function useSetPreferredDealer() {
  const client = (0, _reactQuery.useQueryClient)();
  return (0, _reactQuery.useMutation)({
    mutationFn: function (_ref16) {
      let {
        vin,
        dealerCode
      } = _ref16;
      return EOS.vehicleManagement({}).post(actions.setPreferredDealer, {
        vinList: [{
          vin
        }],
        dealerCode
      });
    },
    onSuccess: function (_, _ref17) {
      let {
        vin
      } = _ref17;
      client.invalidateQueries({
        queryKey: ["user-vehicles", true]
      });
      client.invalidateQueries({
        queryKey: ["dealers-by-vin", vin]
      });
    }
  });
}
function useRenameVehicle() {
  const client = (0, _reactQuery.useQueryClient)();
  return (0, _reactQuery.useMutation)({
    mutationFn: function (_ref18) {
      let {
        vehicleId,
        model,
        year,
        nickname
      } = _ref18;
      return EOS.vehicleManagement({
        vehicleId
      }).patch(actions.renameVehicle, {
        model: (vehicleId === null || vehicleId === void 0 ? void 0 : vehicleId.length) > 17 ? model : undefined,
        nickName: nickname,
        reason: "",
        reportedBy: "OWNER",
        year: (vehicleId === null || vehicleId === void 0 ? void 0 : vehicleId.length) > 17 ? year : undefined
      });
    },
    onSettled: async function () {
      return client.invalidateQueries({
        queryKey: ["user-vehicles"]
      });
    }
  });
}
const getEngineTransDrive = function (division, engine, transmission, driveType, model, year, lastKnownMileage) {
  return EOS.vehicleMaintenance({
    oauth: oauth.getEngineTransDrive
  }).post(actions.getEngineTransDrive, {
    division: division || "LEXUS",
    engine,
    transmission,
    driveType,
    model,
    year,
    lastKnownMileage
  });
};
function useGetEngineTransDrive(_ref19) {
  let {
    engine,
    transmission,
    driveType,
    model,
    year,
    lastKnownMileage
  } = _ref19;
  let enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const {
    data = {},
    isInitialLoading,
    ...rest
  } = (0, _reactQuery.useQuery)(["etd", {
    driveType,
    model,
    year,
    lastKnownMileage
  }], function () {
    return getEngineTransDrive("LEXUS", engine, transmission, driveType, model, year, lastKnownMileage);
  }, {
    enabled: !!(engine && transmission && driveType && model && year) && enabled,
    select: function (data) {
      var _data$data5;
      return data === null || data === void 0 ? void 0 : (_data$data5 = data.data) === null || _data$data5 === void 0 ? void 0 : _data$data5.data;
    }
  });
  return {
    ...data.scheduleMaintenance,
    isInitialLoading,
    ...rest
  };
}
const getVinMaintenanceSchedule = function (vin, lastMileage) {
  return EOS.vehicleMaintenance({
    oauth: oauth.getMaintenanceScheduleVIN
  }).post(actions.getVinMaintenanceSchedule, {
    vin,
    operCondid: "",
    specialInstructionId: "",
    lastKnownMileage: lastMileage
  });
};
const getMaintenanceSchedule = function (model, year) {
  return EOS.vehicleMaintenance({
    oauth: oauth.getMaintenanceSchedule,
    captcha: false
  }).post(actions.getMaintenanceSchedule, {
    model,
    year,
    division: "LEXUS"
  });
};
function useGetMaintenanceSchedule(vin, pModel, year, driveType, lastKnownMileage) {
  var _vinQuery$data, _vinQuery$data$data, _modelYearQuery$data, _modelYearQuery$data$, _modelYearData$schedu, _modelYearData$schedu2, _modelYearData$schedu3;
  const model = pModel !== null && pModel !== void 0 && pModel.endsWith("L") ? pModel.replace("L", "") : pModel;
  const hasModelAndYear = model && year;
  const lastMileage = !lastKnownMileage || lastKnownMileage === "0" ? "5000" : lastKnownMileage;
  const vinQuery = (0, _reactQuery.useQuery)(["maintenance-schedule", vin, lastMileage], function () {
    return getVinMaintenanceSchedule(vin, lastMileage);
  }, {
    enabled: !!vin
  });
  const modelYearQuery = (0, _reactQuery.useQuery)(["maintenance-schedule", model, year], function () {
    return getMaintenanceSchedule(model, year);
  }, {
    enabled: !!(hasModelAndYear && !vin)
  });
  const vinData = (_vinQuery$data = vinQuery.data) === null || _vinQuery$data === void 0 ? void 0 : (_vinQuery$data$data = _vinQuery$data.data) === null || _vinQuery$data$data === void 0 ? void 0 : _vinQuery$data$data.data;
  const modelYearData = ((_modelYearQuery$data = modelYearQuery.data) === null || _modelYearQuery$data === void 0 ? void 0 : (_modelYearQuery$data$ = _modelYearQuery$data.data) === null || _modelYearQuery$data$ === void 0 ? void 0 : _modelYearQuery$data$.data) || {};
  const maintenanceScheduledEngineDriveType = (modelYearData === null || modelYearData === void 0 ? void 0 : (_modelYearData$schedu = modelYearData.scheduleMaintenance) === null || _modelYearData$schedu === void 0 ? void 0 : _modelYearData$schedu.engineTransDrive[0]) || {};
  const engineTransDrive = {
    ...driveType,
    ...maintenanceScheduledEngineDriveType
  };
  const mileage = lastKnownMileage || ((modelYearData === null || modelYearData === void 0 ? void 0 : (_modelYearData$schedu2 = modelYearData.scheduleMaintenance) === null || _modelYearData$schedu2 === void 0 ? void 0 : _modelYearData$schedu2.lastKnownMileage) === "0" || !lastKnownMileage ? "5000" : modelYearData === null || modelYearData === void 0 ? void 0 : (_modelYearData$schedu3 = modelYearData.scheduleMaintenance) === null || _modelYearData$schedu3 === void 0 ? void 0 : _modelYearData$schedu3.lastKnownMileage);
  const hasApiData = Object.keys(modelYearData).length > 0;
  const driveData = useGetEngineTransDrive({
    ...engineTransDrive,
    model,
    year,
    lastKnownMileage: mileage
  }, !vin && hasApiData);
  const maintenanceSchedule = (vinData === null || vinData === void 0 ? void 0 : vinData.scheduleMaintenance) || driveData;
  return {
    etdList: maintenanceSchedule === null || maintenanceSchedule === void 0 ? void 0 : maintenanceSchedule.engineTransDrive,
    ...maintenanceSchedule,
    isInitialLoading: (vinQuery === null || vinQuery === void 0 ? void 0 : vinQuery.isInitialLoading) || (modelYearQuery === null || modelYearQuery === void 0 ? void 0 : modelYearQuery.isInitialLoading) || (driveData === null || driveData === void 0 ? void 0 : driveData.isInitialLoading)
  };
}
const getVehicleSpecifications = function (vin) {
  return EOS.vehicleInfo({
    oauth: oauth.getVehicleSpecs
  }).post(actions.getVehicleSpecs, {
    vin
  });
};
function useVehicleSpecifications(vin) {
  return (0, _reactQuery.useQuery)(["vehicle-specs", vin], function () {
    return getVehicleSpecifications(vin);
  }, {
    enabled: !!vin,
    select: function (responseData) {
      var _responseData$data4;
      return responseData === null || responseData === void 0 ? void 0 : (_responseData$data4 = responseData.data) === null || _responseData$data4 === void 0 ? void 0 : _responseData$data4.data;
    }
  });
}
const getVehicleHealth = function (vin) {
  return EOS.vehicleHealth({
    vin
  }).get(actions.getVehicleHealthHistory);
};
function useGetVehicleHealthHistory(vin) {
  return (0, _reactQuery.useQuery)(["vehicle-health-history", vin], function () {
    return getVehicleHealth(vin);
  }, {
    enabled: !!vin,
    select: function (responseData) {
      var _responseData$data5, _responseData$data5$d;
      return responseData === null || responseData === void 0 ? void 0 : (_responseData$data5 = responseData.data) === null || _responseData$data5 === void 0 ? void 0 : (_responseData$data5$d = _responseData$data5.data) === null || _responseData$data5$d === void 0 ? void 0 : _responseData$data5$d.vhrData;
    }
  });
}
function getPDF(vin, vhrId) {
  if (vin && vhrId) {
    apiClient({
      headers: {
        accept: "application/pdf"
      },
      opts: {
        responseType: "blob"
      },
      params: {
        vin,
        vhrId
      }
    }).get(actions.getPDF).then(function (res) {
      var _res$data;
      const link = document.createElement("a");
      link.href = URL.createObjectURL(new Blob([res.data]));
      link.download = `vehicle-health-report.${vhrId}.pdf`;
      document.body.append(link);
      link.click();
      return res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data;
    }).catch(function (err) {
      return err;
    });
  }
}